







































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import Api from '@/api/marketing/live/index'

@Component({
  components: {
    PicModal,
  },
})
export default class EditArticleCategory extends AbpBase {
  priceType: string = '一口价'
  onePrice: any = '0'
  oldPrice: any = '0'
  newPrice: any = '0'
  form = {
    name: null,
    coverImgUrl: null,
  }

  ruleForm = {
    coverImgUrl: [{ required: true, message: '请选择分类图', trigger: 'blur' }],
    name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
  }

  created() {
    this.getCategory()
  }

  /**
   * 根据id获取直播间商品信息
   */
  getCategory() {
    let id = this.$route.query['id']
    if (id) {
      Api.getLiveGoodsInfoById(id.toString()).then((res) => {
        console.log(res)
        this.form = res.data
        this.priceType = res.data.priceType == 1 ? '一口价' : '折扣价'
        if (res.data.priceType == 1) {
          this.onePrice = res.data.price
        } else if (res.data.priceType == 3) {
          this.oldPrice = res.data.price
          this.newPrice = res.data.price2
        }
      })
    }
  }

  picChange(e) {
    this.form.coverImgUrl = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        if (vm.priceType == '一口价') {
          ;(vm.form as any).price = vm.onePrice
          ;(vm.form as any).priceType = 1
        } else {
          ;(vm.form as any).price = vm.oldPrice
          ;(vm.form as any).price2 = vm.newPrice
          ;(vm.form as any).priceType = 3
        }
        if ((vm.form as any).price2 == null) {
          ;(vm.form as any).price2 = 0
        }

        if ((vm.form as any).priceType == 3) {
          if ((vm.form as any).price <= (vm.form as any).price2) {
            this.$Notice.error({ desc: '现价要低于原价' })
            return
          }
        }

        Api.updatedGoodsInfoById(id, vm.form).then((res) => {
          console.log('6867')
          vm.$router.push({
            name: 'liveRoomCommodity',
          })
        })
      }
    })
  }
}
